import React, { useEffect, useState } from 'react'
import { Container, Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { getAllBlogs } from '../services/Apis';

const Blog = () => {
	const navigate = useNavigate()
	const [blogData, setBlogData] = useState([])
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchBlogs = async () => {
			const blogs = await getAllBlogs();
			 // Simulate loading delay
				setBlogData(blogs);
				setLoading(false);
		
		};
		fetchBlogs();
	}, [])
		// size={{ xs: 12; sm: 6; md: 4; lg: 2 }}
	// Helper to format date/time
	const formatDate = (dateString) => {
		const date = new Date(dateString);
		return date.toLocaleDateString();
	};
	const formatTime = (dateString) => {
		const date = new Date(dateString);
		return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
	};

	return (
		<Container
			maxWidth="xl"
			sx={{
				py: 3, boxSizing: 'border-box',

				// px: { xs: 1, sm: 2, md: 3 },
				// overflowX: 'hidden',
			}}
		>
			<Typography variant="h5" fontSize={'24px'} fontWeight={500} mb={3}>
				Blog
			</Typography>
			{loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 220 }}>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <span className="red-dot" />
                        <span className="red-dot" style={{ animationDelay: '0.2s' }} />
                        <span className="red-dot" style={{ animationDelay: '0.4s' }} />
                    </Box>
                    <style>
                        {`
                        .red-dot {
                            display: inline-block;
                            width: 14px;
                            height: 14px;
                            border-radius: 50%;
                            background: #CB4422;
                            margin: 0 4px;
                            animation: bounce 1s infinite;
                        }
                        @keyframes bounce {
                            0%, 80%, 100% { transform: scale(1); opacity: 1; }
                            40% { transform: scale(1.4); opacity: 0.7; }
                        }
                        `}
                    </style>
                </Box>
            ):(<Box
				sx={{
					display: 'flex',
					flexWrap: 'wrap',
					gap: 3,
					justifyContent: 'left',
					width: '100%',
					boxSizing: 'border-box',
					m: 0,
				}}
			>
				{blogData.map((blog) => (
					<Box
						key={blog.id}
						sx={{
							flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 320px' },
							maxWidth: { xs: '100%', sm: '100%', md: 410 },
							bgcolor: '#fff',
							borderRadius: 2,
							overflow: 'hidden',
							mb: 2,
							display: 'flex',
							alignItems: 'center',
							flexDirection: 'column',
							boxSizing: 'border-box',
						}}
					>
						<Box
							component="img"
							onClick={() => navigate(`/category-blog/${blog.id}`)} 
							src={blog.imageUrl}
							alt={blog.title}
							sx={{width: '100%',height: 220,borderRadius: '8px 8px 8px 8px',}}
						/>
						<Box sx={{ p: 2, flex: 1, display: 'flex', width: '100%', flexDirection: 'column' }}>
							{/* Date & Time Row */}
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
								<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
									<i className="fas fa-calendar-alt" style={{ color: '#cb4422', fontSize: 14 }} />
									<Typography sx={{ fontSize: 13, color: '#555' }}>
										{formatDate(blog.createdAt)}
									</Typography>
								</Box>
								<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
									<i className="fas fa-clock" style={{ color: '#cb4422', fontSize: 14 }} />
									<Typography sx={{ fontSize: 13, color: '#555' }}>
										{formatTime(blog.createdAt)}
									</Typography>
								</Box>
							</Box>
							<Typography variant="h6" fontWeight={600} sx={{ fontSize: 18, mb: 1 }}>
								{blog.title}
							</Typography>
							<Typography
								sx={{
									fontSize: 14,
									color: '#444',
									mb: 2,
									flex: 1,
									display: '-webkit-box',
									WebkitLineClamp: 4,
									WebkitBoxOrient: 'vertical',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
								}}
							>
								<Box
									sx={{
										p: 0,
										'& *': {
											padding: 0,
											margin: 0,
											boxSizing: 'border-box',
										},
									}}
								>
									<span dangerouslySetInnerHTML={{ __html: blog.content }} />
								</Box>
							</Typography>
							<Button
								variant="text"
								sx={{
									color: '#cb4422',
									fontWeight: 500,
									fontSize: 14,
									textTransform: 'none',
									px: 0,
									alignSelf: 'flex-start',
								}}
								onClick={() => navigate(`/category-blog/${blog.id}`)} // <-- Pass blog id in URL
							>
								Read more
							</Button>
						</Box>
					</Box>
				))}
			</Box>)}
		</Container>
	)
}

export default Blog